/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from 'react';
import Specialty from '../../forms/specialty';
import restApiClient from '../../services/restApiClient';
import FilterTree from '../../helpers/filterTree';
import { isEmpty } from 'lodash';
import { Hidden } from '@material-ui/core';
import AdornedTextField from '../adornedTextField';
import {
  Container,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  AddBox,
  StyledCrudTable,
  HandHoldingMedical,
} from './styles';

const SelectSpecialtyDialogControl = ({
  data,
  className,
  id,
  enabled,
  uischema,
  schema,
  path,
  label,
  handleChange,
  onSuccess,
  config,
  errors,
  visible,
  disabled,
  ...props
}) => {
  const [open, setOpen] = React.useState(false);
  const [selectedSpecialty, setSelectedSpecialty] = React.useState({});
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState({ count: 0, values: [] });
  const [rowsPerPage, setRowsPerPage] = useState(3);
  const [orderBy, setOrderby] = useState({ id: 'asc' });
  const [searchBy, setSearchBy] = useState('');
  const columns = Specialty.tableSchema;

  const handleClickOpen = () => {
    if (enabled) {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    restApiClient.specialty
      .getAll(
        rowsPerPage,
        page * rowsPerPage,
        searchBy ? new FilterTree().like('name', searchBy).toString() : null,
        orderBy
      )
      .then((e) => {
        setRows(e.data);
      });
  }, [rowsPerPage, page, orderBy, searchBy]);

  useEffect(() => {
    if (data) {
      restApiClient.specialty.findById(data).then((e) => {
        setSelectedSpecialty(e.data);
      });
    } else {
      setSelectedSpecialty({});
    }
  }, [data]);

  return (
    <Hidden xsUp={!visible}>
      <Container>
        <AdornedTextField
          disabled={!enabled}
          error={!isEmpty(errors)}
          adornment={<HandHoldingMedical />}
          clickableAdornment
          onAdornmentClick={handleClickOpen}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={handleClickOpen}
          label="Especialidade"
          InputLabelProps={{
            shrink: true,
            readOnly: true,
          }}
          value={selectedSpecialty?.name ?? ''}
        />

        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          open={open}
          onClose={handleClose}
        >
          <DialogContent>
            <StyledCrudTable
              title={'Seleção de Especialidade'}
              modelActions={Specialty.actions}
              columns={columns}
              rows={rows}
              page={page}
              setPage={(page) => setPage(page)}
              rowsPerPage={rowsPerPage}
              availableRowsPerPage={[3]}
              setRowsPerPage={(rowsPerPage) => setRowsPerPage(rowsPerPage)}
              onOrderByChange={(orderBy) => setOrderby(orderBy)}
              orderBy={orderBy}
              setOrderBy={(value) => setOrderby(value)}
              searchBy={searchBy}
              setSearchBy={(value) => setSearchBy(value)}
              actions={{
                insert: {
                  icon: <AddBox />,
                  onClick: (id, data) => {
                    setSelectedSpecialty(id);
                    handleChange?.(path, id);
                    onSuccess?.(id);
                    handleClose();
                  },
                  title: 'Vincular',
                  allowedActions: [Specialty.actions.getAll],
                },
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancelar
            </Button>
            <Button onClick={handleClose} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Hidden>
  );
};

export default SelectSpecialtyDialogControl;
